module.exports = __webpack_public_path__ + "img/inspiration_06.9de79f5.webp";